import { useEffect } from "react";

const DEFAULT_TITLE = "Analytics 4 People — Working better with data";
const DEFAULT_DESC =
  "Analytics 4 People — Working better with data. People Analytics, Cloud & Infraestructura AWS y Growth Analytics.";

const setMeta = (attr, key, content) => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export const useSeo = ({ title, description, image, lang, type = "website" }) => {
  useEffect(() => {
    if (!title) return;
    const full = title.includes("Analytics 4 People") ? title : `${title} | Analytics 4 People`;
    document.title = full;
    if (lang) document.documentElement.lang = lang;
    setMeta("name", "description", description);
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", type);
    setMeta("property", "og:url", window.location.href);
    setMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
    setMeta("name", "twitter:title", full);
    setMeta("name", "twitter:description", description);
    if (image) {
      setMeta("property", "og:image", image.startsWith("http") ? image : `${window.location.origin}${image}`);
    }
    setCanonical(window.location.href);
    return () => {
      document.title = DEFAULT_TITLE;
      setMeta("name", "description", DEFAULT_DESC);
    };
  }, [title, description, image, lang, type]);
};
